import { render, staticRenderFns } from "./researchSchools.vue?vue&type=template&id=5d42e718&"
import script from "./researchSchools.vue?vue&type=script&lang=js&"
export * from "./researchSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports